var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row amount-row\"> <div class=\"select-wrapper col-xs-4 col-md-1\"> <select ng-model=\"$ctrl.selected\" ng-options=\"option.value disable when option.disabled for option in $ctrl.options track by option.value\" ng-change=\"$ctrl.read()\" ng-disabled=\"$ctrl.isDisabled()\"> <option ng-if=\"$ctrl.selected === null\" value=\"\">({{ $ctrl.value }})</option> </select> </div> <span class=\"col-xs-3 col-md-5\">{{ $ctrl.item.name }}</span>\n<span class=\"col-xs-5 col-md-6\" style=\"text-align: right; padding-right: 0; word-break: break-all\">{{ $ctrl.item.price | currency:'€' }}</span> </div>";
var id1="winresServiceSelectAmount.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceSelectAmount/winresServiceSelectAmount.html
// module id = 470
// module chunks = 2